import styled, { css } from "styled-components";
import {
  mediaMax,
  mediaMin,
  headerSizes,
  theme,
  fade
} from "../../shared/style";
import { Article, Section } from "../../components/QuickCard";
const Root = styled.div`
  display: flex;
  align-items: center;
  min-height: 100vh;
  ${Article} {
    ${mediaMin.phone` max-width: 480px;`};
  }
  ${Section} {
    padding: 16px;
    ${mediaMax.phone`    display: flex;
    flex-direction: column;
    min-height: 100vh`};
  }
`;
const Title = styled.h2`
  margin: 0 0 16px;
  font-family: Montserrat;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: normal;
  color: ${theme.IndiqoGrey[800]};
`;
const Text = styled.p`
  margin-top: 0;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: 0.25px;
  color: ${theme.IndiqoGrey[800]};
  i {
    color: ${theme.IndiqoGrey[400]};
  }
`;
const Btn = styled.button`
  cursor: pointer;
  display: block;
  margin: 0 auto;
  text-transform: uppercase;
  width: 200px;
  height: 40px;
  border-radius: 100px;
  border: solid 1px ${theme.OrangeyRed[200]};
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: 1px;
  text-align: center;
  color: ${theme.White};

  background-image: linear-gradient(
    to bottom,
    ${theme.OrangeyRed[100]},
    ${theme.OrangeyRed[200]}
  );
  &:hover {
    background-image: linear-gradient(
      to bottom,
      ${theme.OrangeyRed[200]},
      ${theme.OrangeyRed[100]}
    );
  }
`;

const ContentWrapper = styled.div`
  padding: 0 8px;
`;
const RadioWrapper = styled.div`
  padding: 6px 0 10px;
`;
const DropDownWrapper = styled.div`
  position: relative;
`;

const DropDownBtn = styled.button`
  padding: 0 12px;
  cursor: pointer;
  width: 100%;
  height: 44px;
  border-radius: 4px;
  border: solid 1px ${theme.IndiqoGrey[300]};
  background-color: ${theme.IndiqoGrey.main};
  font-family: Lato;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: normal;
  color: ${theme.IndiqoGrey[800]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  i {
    color: ${theme.IndiqoGrey[500]};
    transition: 0.3s;
    ${props =>
      props.active &&
      css`
        transform: scaleY(-1);
      `};
  }
`;
const DropDownOptions = styled.div`
  position: absolute;
  margin-top: 4px;
  top: 100%;
  left: 0;
  z-index: 1;
  width: 100%;
  height: ${props => (props.active ? `${props.count * 36}` : "0")}px;
  overflow: hidden;
  transition: 0.3s;
  border-radius: 8px;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 6px 10px 0 rgba(0, 0, 0, 0.14);
`;
const DropDownOption = styled.button`
  height: 36px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${theme.IndiqoGrey[800]};
  background: ${theme.White};
  padding: 0 12px;
  border: 0;

  cursor: pointer;
  &:hover {
    background: ${theme.IndiqoGrey[100]};
  }
  i {
    font-size: 16px;
    color: ${theme.Primary.main};
  }
`;

const MessageWrapper = styled.div`
  padding: 0 ${40 - 16}px;
`;
const TextArea = styled.textarea`
  padding: 12px;
  width: 100% !important;
  min-height: 64px;
  border-radius: 4px;
  border: solid 1px ${theme.IndiqoGrey[300]};
  background-color: ${theme.IndiqoGrey.main};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: normal;
  margin-bottom: 12px;
  max-width: 100% !important;
  min-width: 100% !important;
`;

const PoweredBy = styled.img`
  display: block;
  margin: 0 auto;
  max-height: 24px;
  width: 134px !important;
  object-fit: contain;

  ${props =>
    props.phone &&
    css`
      margin-top: 16px;
      ${mediaMin.phone`display:none`};
    `};
    
     ${props =>
    props.desktop &&
    css`
      ${mediaMax.phone`display:none`};
    `};
`;

export default {
  Root,
  Title,
  Text,
  Btn,
  ContentWrapper,
  RadioWrapper,
  DropDownWrapper,
  DropDownBtn,
  DropDownOptions,
  DropDownOption,
  MessageWrapper,
  TextArea,
  PoweredBy
};
